// extracted by mini-css-extract-plugin
export default {"storyDetailHeaderDescription":"c-r_hn","storyDetailHeaderDescription__time":"c-r_ho"};